export enum SlotGameEventExtension{
    BUY_FREESPINS = 'onBuyFreespins'
}
